import React from 'react'
import "./footer.css"

const Footer = () => {
  return (
    <footer className='footer'>
      Copyright &copy; {new Date().getFullYear()} Blaise Khan. All right reserved
    </footer>
  )
}

export default Footer
